var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleRight = function SvgAngleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.434 5.151c.198-.198.297-.297.411-.334a.5.5 0 0 1 .31 0c.114.037.213.136.41.334l6.284 6.283c.198.198.296.297.334.412.032.1.032.208 0 .309-.038.114-.136.213-.335.41L9.567 18.85c-.198.198-.297.296-.411.334a.5.5 0 0 1-.31 0c-.114-.038-.213-.136-.41-.334l-.284-.283c-.198-.198-.297-.297-.334-.412a.5.5 0 0 1 0-.308c.037-.115.136-.214.334-.412L13.586 12 8.15 6.566c-.198-.198-.297-.297-.334-.411a.5.5 0 0 1 0-.31c.037-.114.136-.213.334-.41z",
    clipRule: "evenodd"
  })));
};
export default SvgAngleRight;